import { __rest, __assign } from './../../vendor/tslib/tslib.es6.js';
import React__default from 'react';
import classNames from 'classnames';
import colors from '../../color/neutrals.module.css.js';
import styles from './Typography.module.css.js';

var Typography = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.align, align = _b === void 0 ? 'match-parent' : _b, _c = _a.color, color = _c === void 0 ? 'neutral-700' : _c, _d = _a.as, as = _d === void 0 ? 'p' : _d, _e = _a.variant, variant = _e === void 0 ? 'body-md' : _e, marmaladeBase = __rest(_a, ["children", "className", "align", "color", "as", "variant"]);
    var Element = as;
    var rootClassName = classNames(styles.root, colors[color], styles[variant], className, styles["align-".concat(align)]);
    return (React__default.createElement(Element, __assign({ className: rootClassName, style: {
            '--TypographyColor': colors[color],
        } }, marmaladeBase), children));
};

export { Typography };
//# sourceMappingURL=Typography.js.map
